import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { adminMainUrl } from "../../../Config";
import Cookies from "js-cookie";
// import { BeatLoader } from "react-spinners";

import "react-datepicker/dist/react-datepicker.css";
import { useFormik } from "formik";
import axios from 'axios';
import Accordion from 'react-bootstrap/Accordion';
import { toast } from 'react-toastify';
import { RemarkModal } from "../../Modal/RemarkModal";
import QuotationAirExportModal from "./ExportModal/QuotationAirExportModal";
import { useDispatch, useSelector } from "react-redux";
import Beatloader from "../../../Common/Loaders/Beatloader";
import { getPricingQuoteDetail } from "../../../Redux/action/Sales/LeadStatusAction";
// import { RemarkModal } from "../../Modal/RemarkModal";

const ViewInformation = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [quotationId, setQuotationId] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [spinnerLoader, setSpinnerLoader] = useState(true);
    const [viewData, setViewData] = useState([]);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showRemark, setShowRemark] = useState(false);
    const handleCloseRemark = () => setShowRemark(false);
    const handleShowRemark = () => setShowRemark(true);


    const [showPageLoader, setShowPageLoader] = useState(true);
    const location = useLocation();

    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;
    const token = Cookies.get('token');
    useEffect(() => {
        if (!token) {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        } else {
            if (location.state?.quotationId) {
                setQuotationId(location.state.quotationId);
                dispatch(getPricingQuoteDetail(token, location.state?.quotationId))
            } else {
                toast.error("Quotation ID not found.");
                navigate(-1);
            }
        }

    }, [location.state, token]);


    //get data from redux

    const { loadingPricingQuoteDetail, pricingQuoteDetailDataError, pricingQuoteDetailData } = useSelector(state => state?.LeadStatusReducer);

    useEffect(() => {
        if (loadingPricingQuoteDetail) {
            setShowPageLoader(true);
        } else {
            setShowPageLoader(false);
        }

        // console.log(pricingQuoteDetailData);

    }, [loadingPricingQuoteDetail, pricingQuoteDetailDataError, pricingQuoteDetailData])
    const [isVisible, setIsVisible] = useState(false);
    const handleToggle = () => {
        setIsVisible(!isVisible);
    };

    function formatDate(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so we add 1
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    }

    const parsedFiles = JSON.parse(viewData?.files || "[]");
    const formik = useFormik({
        initialValues: {
            remarks: '', // Add an initial value for remarks
        },
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            setIsSubmitting(true);

            try {
                const token = Cookies.get("token");
                const requestId = {
                    quotation_id: `${quotationId}`,
                    remarks: values.remarks, // Pass the remarks from the form
                };
                const response = await fetch(`${adminMainUrl}/api/pricing/store-remarks`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "auth-token": token,
                    },
                    body: JSON.stringify(requestId),
                });
                // ViewQuotation();
                dispatch(getPricingQuoteDetail(token, location.state?.quotationId))

                const result = await response.json(); // Parse the response
                resetForm(); // Reset form fields
                toast.success(result.msg); // Display the success message
                setSubmitting(false);
            } catch (error) {
                console.error(error);
                setSubmitting(false);
            } finally {
                setIsSubmitting(false); // Stop the spinner
                setIsVisible(false)
            }
        },
    });
    return (
        <div className="page-wrapper">

            {

                showPageLoader ?
                    <Beatloader />
                    :
                    <div className="content">
                        <div className="row">
                            <div className="col-md-12">
                                {/* Page Header */}
                                <div className="page-header">
                                    <div className="row align-items-center">
                                        <div className="col-sm-4">
                                            <h4 className="page-title">
                                                View Information
                                            </h4>
                                        </div>
                                        <div className="col-sm-8 text-sm-end">
                                            <div className="head-icons">
                                                {/* <a
                                            href="#"
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            data-bs-original-title="Refresh"
                                        >
                                            <i className="ti ti-refresh-dot" />
                                        </a> */}
                                                <a
                                                    href="javascript:void(0);"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    data-bs-original-title="Collapse"
                                                    id="collapse-header"
                                                >
                                                    <i className="ti ti-chevrons-up" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* /Page Header */}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                {/* Contact User */}
                                <div className="contact-head">
                                    <div className="row align-items-center">
                                        <div className="col-sm-6">
                                            <ul className="contact-breadcrumb">
                                                <li>
                                                    <Link to={-1}>
                                                        <i className="ti ti-arrow-narrow-left" />
                                                        View Information
                                                    </Link>
                                                </li>

                                            </ul>
                                        </div>

                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-body pb-2">
                                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                                            <div className="d-flex align-items-center mb-2">

                                                <div>
                                                    <h5 className="mb-1">{pricingQuoteDetailData?.full_name}</h5>
                                                    <p className="mb-2">Request No : {pricingQuoteDetailData?.request_no}</p>
                                                    <div className="d-flex align-items-center">
                                                        <span className="badge badge-light bg-light-600 text-default me-3">
                                                            <i className="ti ti-lock me-1" />
                                                            {pricingQuoteDetailData?.quote_status?.name}
                                                        </span>

                                                    </div>
                                                </div>
                                            </div>
                                            {
                                                pricingQuoteDetailData?.quote_status?.name === "Price Received" ? (
                                                    <div className="contacts-action gap-2">
                                                        <div className="w-fit">
                                                            <div
                                                                className="btn btn-danger"
                                                                onClick={() => { navigate(`/flexichain/export-view-rates/${btoa(quotationId)}`) }}
                                                            >
                                                                View Rates
                                                            </div>
                                                        </div>
                                                        {/* Uncomment if needed */}
                                                        {/* </div> */}
                                                        <div className="w-fit">
                                                            <div
                                                                onClick={handleShowRemark}
                                                                className="send_query_list_button send-query btn btn-danger"
                                                            >
                                                                View Remark
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : pricingQuoteDetailData?.quote_status?.name === "Repricing" ? (
                                                    <div className="contacts-action gap-2">
                                                        <div className="w-fit">
                                                            <div
                                                                className="btn btn-danger"
                                                                onClick={() => { navigate(`/flexichain/export-view-rates/${btoa(quotationId)}`) }}
                                                            >
                                                                View Rates
                                                            </div>
                                                        </div>

                                                        <div className="w-fit">
                                                            <div
                                                                onClick={handleShowRemark}
                                                                className="send_query_list_button send-query btn btn-danger"
                                                            >
                                                                View Remark
                                                            </div>
                                                        </div>
                                                        {/* Uncomment if needed */}

                                                    </div>
                                                ) : (
                                                    <div className="contacts-action gap-2">

                                                        <div className="w-fit">
                                                            <div
                                                                className="btn btn-danger"
                                                                onClick={handleShow}
                                                            >
                                                                Give Rates
                                                            </div>

                                                        </div>

                                                        <div className="w-fit">
                                                            <div
                                                                onClick={handleShowRemark}
                                                                className="send_query_list_button send-query btn btn-danger"
                                                            >
                                                                View Remark
                                                            </div>
                                                        </div>
                                                        {/* Uncomment if needed */}
                                                    </div>
                                                )
                                            }


                                            {/* <div className="contacts-action">
                                     

                                        <a
                                            href="#"
                                            className="btn btn-danger"
                                            data-bs-toggle="offcanvas"
                                            data-bs-target="#offcanvas_add_2"
                                        >
                                            <i className="ti ti-circle-plus" />
                                            Add Deal
                                        </a>
                                        <a
                                            href="#"
                                            className="btn btn-primary"
                                            data-bs-toggle="modal"
                                            data-bs-target="#add_compose"
                                        >
                                            <i className="ti ti-mail" />
                                            Send Email
                                        </a>
                                       
                                    </div> */}
                                        </div>
                                    </div>
                                </div>
                                {/* /Contact User */}
                            </div>
                            {/* Contact Sidebar */}
                            <div className="col-xl-4 ">
                                <div className="card">
                                    <div className="card-body p-3">
                                        <h6 className="mb-3 fw-semibold">General Information</h6>
                                        <div className="mb-3">
                                            <div className="d-flex align-items-center mb-3">
                                                <span className="avatar avatar-xs bg-light-300 p-0 flex-shrink-0 rounded-circle text-dark me-2">
                                                    <i className="ti ti-mail" />
                                                </span>
                                                <p>{pricingQuoteDetailData?.email} ({pricingQuoteDetailData?.quotation_user_type})</p>
                                            </div>
                                            <div className="d-flex align-items-center mb-3">
                                                <span className="avatar avatar-xs bg-light-300 p-0 flex-shrink-0 rounded-circle text-dark me-2">
                                                    <i className="ti ti-phone" />
                                                </span>
                                                <p>{pricingQuoteDetailData?.phone}</p>
                                            </div>

                                            <div className="d-flex align-items-center mb-3">
                                                <span className="avatar avatar-xs bg-light-300 p-0 flex-shrink-0 rounded-circle text-dark me-2">
                                                    <i className="ti ti-calendar-exclamation" />
                                                </span>
                                                <p>Created at {formatDate(pricingQuoteDetailData?.createdAt)}</p>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            {/* /Contact Sidebar */}
                            {/* Contact Details */}
                            <div className="col-xl-8">
                                <div className="card mb-3">
                                    <div className="card-body pb-0 pt-2">
                                        <ul className="nav nav-tabs nav-tabs-bottom" role="tablist">
                                            <li className="nav-item" role="presentation">
                                                <a
                                                    href="#"
                                                    data-bs-toggle="tab"
                                                    data-bs-target="#activities"
                                                    className="nav-link active"
                                                >
                                                    <i className="ti ti-alarm-minus me-1" />
                                                    Pickup Information
                                                </a>
                                            </li>
                                            {/* <li className="nav-item" role="presentation">
                                        <a
                                            href="#"
                                            data-bs-toggle="tab"
                                            data-bs-target="#notes"
                                            className="nav-link"
                                        >
                                            <i className="ti ti-notes me-1" />
                                            documents or Videos

                                        </a>
                                    </li> */}

                                        </ul>
                                    </div>
                                </div>
                                {/* Tab Content */}
                                <div className="tab-content pt-0">
                                    {/* Activities */}
                                    <div className="tab-pane active show" id="activities">
                                        <div className="card">



                                            <div className="card-body">
                                                <div className="pb-4 px-md-4 px-3 view-info-box">
                                                    <div className="row">
                                                        <div className=" col-md-6 py-2">
                                                            <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Origin </p>
                                                                {/* <div className="box-query"> */}
                                                                <p className="mb-0 text-sm">{pricingQuoteDetailData?.origin_type == "AIRPORT" ? "Delhi, India" : `${pricingQuoteDetailData?.origin_address}, ${pricingQuoteDetailData?.origin_city ? pricingQuoteDetailData?.origin_city?.name : ""}, ${pricingQuoteDetailData?.origin_state ? pricingQuoteDetailData?.origin_state?.name : ""}, ${pricingQuoteDetailData?.origin_country ? pricingQuoteDetailData?.origin_country?.name : ""} `}</p>

                                                            </div>
                                                            <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Destination</p>
                                                                {/* <div className="box-query"> */}

                                                                <p className="mb-0 text-sm">{pricingQuoteDetailData?.destination_type == "AIRPORT" ? "Delhi, India" : `${pricingQuoteDetailData?.destination_address}, ${pricingQuoteDetailData?.destination_city ? pricingQuoteDetailData?.destination_city?.name : ""}, ${pricingQuoteDetailData?.destination_state ? pricingQuoteDetailData?.destination_state?.name : ""}, ${pricingQuoteDetailData?.destination_country ? pricingQuoteDetailData?.destination_country?.name : ""} `}</p>

                                                            </div>
                                                            {pricingQuoteDetailData?.shipment_mode !== "courier" && <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Incoterm</p>

                                                                <p className="mb-0 text-sm">{pricingQuoteDetailData?.incoterm ? pricingQuoteDetailData?.incoterm?.name : ""}</p>

                                                            </div>}



                                                        </div>
                                                        <div className=" col-md-6 py-2">
                                                            <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Shipment Mode </p>
                                                                {/* <div className="box-query"> */}
                                                                <p className="mb-0 text-sm">{pricingQuoteDetailData?.shipment_mode ? pricingQuoteDetailData?.shipment_mode : ""}</p>

                                                            </div>


                                                            <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Cargo Ready Date </p>
                                                                {/* <div className="box-query"> */}

                                                                <p className="mb-0 text-sm">{formatDate(pricingQuoteDetailData?.cargo_ready_date)}</p>

                                                            </div>

                                                            {pricingQuoteDetailData && pricingQuoteDetailData?.shipment_mode !== "air" && pricingQuoteDetailData?.shipment_mode !== "courier" ? <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Load Type </p>
                                                                {/* <div className="box-query"> */}

                                                                <p className="mb-0 text-sm">{pricingQuoteDetailData?.load_type}</p>

                                                            </div> : ""}
                                                        </div>
                                                        <div className="col-12">
                                                            <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Additionals</p>

                                                                <p className="mb-0 text-sm">
                                                                    {pricingQuoteDetailData?.additional_info && pricingQuoteDetailData.additional_info.length > 0
                                                                        ? pricingQuoteDetailData.additional_info.map(info => info.name).join(', ')
                                                                        : "-"
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                        {
                                                            pricingQuoteDetailData?.shipment_mode !== 'air' && pricingQuoteDetailData?.load_type == "FULL" ?
                                                                <div className="col-12 py-2 ">
                                                                    <p className="font-medium mb-3">Cargo Details</p>
                                                                    <div className="table-responsive">
                                                                        <table className="posts-table mb-0 ">
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="p-0">
                                                                                        <tr>
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Quantity
                                                                                            </td>
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Container Size
                                                                                            </td>
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Container Type
                                                                                            </td>
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Unit Weight
                                                                                            </td>
                                                                                        </tr>

                                                                                    </td>

                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="p-0">
                                                                                        <tr>
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                {pricingQuoteDetailData?.fl_quantity ?? "N/A"}
                                                                                            </td>
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                {pricingQuoteDetailData?.containersize ? pricingQuoteDetailData?.containersize?.name : "N/A"}
                                                                                            </td>
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                {pricingQuoteDetailData?.containertype ? pricingQuoteDetailData?.containertype?.name : "N/A"}
                                                                                            </td>
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                {pricingQuoteDetailData?.fl_weight} {pricingQuoteDetailData?.fl_weight_unit_id ?? "N/A"}
                                                                                            </td>
                                                                                        </tr>

                                                                                    </td>
                                                                                </tr>

                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                                :
                                                                <div className="col-12 py-2 ">
                                                                    <p className="font-medium mb-3">Package Dimensions/Weight</p>
                                                                    <div className="table-responsive">
                                                                        <table className="posts-table mb-0 ">
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="p-0">
                                                                                        <tr>
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Length
                                                                                            </td>
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Width
                                                                                            </td>
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Height
                                                                                            </td>
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Type
                                                                                            </td>
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Max Weight
                                                                                            </td>
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Unit
                                                                                            </td>
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Gross Weight
                                                                                            </td>
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Gross Weight Unit
                                                                                            </td>
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Total Box
                                                                                            </td>
                                                                                        </tr>
                                                                                        {
                                                                                            Array.isArray(pricingQuoteDetailData?.package_info) && pricingQuoteDetailData.package_info.length > 0 ? (
                                                                                                pricingQuoteDetailData.package_info.map((value, index) => {
                                                                                                    return (
                                                                                                        <tr key={index}>
                                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                {value?.length || 'N/A'}
                                                                                                            </td>
                                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                {value?.width || 'N/A'}
                                                                                                            </td>
                                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                {value?.height || 'N/A'}
                                                                                                            </td>
                                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                {value?.package_type?.name || 'N/A'}
                                                                                                            </td>
                                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                {value?.max_weight || 'N/A'}
                                                                                                            </td>
                                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                {value?.gross_weight_unit?.name || 'N/A'}
                                                                                                            </td>
                                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                {value?.gross_weight || 'N/A'}
                                                                                                            </td>
                                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                {value?.gross_weight_unit?.name || 'N/A'}
                                                                                                            </td>
                                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                {value?.total_boxes || 'N/A'}
                                                                                                            </td>
                                                                                                        </tr>
                                                                                                    );
                                                                                                })
                                                                                            ) : (
                                                                                                <tr>
                                                                                                    <td colSpan="7" style={{ border: "1px solid #c7c7c7", textAlign: "center" }}>
                                                                                                        No data available
                                                                                                    </td>
                                                                                                </tr>
                                                                                            )
                                                                                        }
                                                                                    </td>
                                                                                </tr>

                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                        }

                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <table className="posts-table w-100">
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="send_query_list_button w-fit p-0 send-query" style={{ background: "none", color: "#000" }}>
                                                                            <div className="remark-section" >
                                                                                <p id="remarks" onClick={handleToggle} className="text-start" style={{ marginRight: '10px', cursor: 'pointer', color: "#E41F07" }}>
                                                                                    + Add Remark
                                                                                </p>
                                                                                <form onSubmit={formik.handleSubmit}>
                                                                                    <div id="remarks" style={{ display: isVisible ? "block" : "none" }}>
                                                                                        <textarea
                                                                                            id="remarks-input"
                                                                                            name="remarks"
                                                                                            className="form-control mb-2"
                                                                                            value={formik.values.remarks}
                                                                                            onChange={formik.handleChange}
                                                                                            onBlur={formik.handleBlur}
                                                                                            placeholder="Write Something Here...."
                                                                                            style={{ marginRight: '10px' }}
                                                                                        ></textarea>
                                                                                        {formik.touched.remarks && formik.errors.remarks ? (
                                                                                            <div className="error" style={{ color: 'red' }}>{formik.errors.remarks}</div>
                                                                                        ) : null}
                                                                                        <div className="text-end">
                                                                                            <button className="send_query_list_button send-query desc-btn py-1 btn btn-danger" disabled={isSubmitting}>
                                                                                                {isSubmitting ? <div><i className="fa fa-spinner fa-spin" /> Add</div> : "Add"}
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                </form>
                                                                            </div>
                                                                        </td>
                                                                    </tr>

                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-pane fade" id="notes">
                                        <div className="card">
                                            <div className="pb-4 px-md-4 px-3 view-info-box">

                                                <div className="row">
                                                    <div className=" col-md-6 py-2">
                                                        <p className="font-medium">Shipment Document </p>
                                                        <div className="col-6 input_box_section file-input-main query-info-flex">
                                                            {parsedFiles?.length > 0 ? (
                                                                parsedFiles?.map((value, index) => {
                                                                    const fileType = value.split('.').pop().toLowerCase();
                                                                    return (
                                                                        <a
                                                                            href={`${adminMainUrl}/${value}`}
                                                                            target="blank"
                                                                        >
                                                                            <button
                                                                                className="folder_main_update_query"
                                                                                key={index}
                                                                            >

                                                                                {fileType === 'jpg' || fileType === 'jpeg' || fileType === 'png' ? (
                                                                                    <img className="document-img" src={`${adminMainUrl}/${value}`} alt="" />
                                                                                ) : (
                                                                                    fileType === 'doc' || fileType === 'docx' || fileType === 'xls' || fileType === 'xlsx' ? (

                                                                                        <iframe
                                                                                            src={`https://docs.google.com/viewer?url=${adminMainUrl}/${value}&embedded=true&embedded=true&toolbar=0`}
                                                                                            frameBorder="0"
                                                                                            width="100%"
                                                                                            height="100%"
                                                                                            scrolling="no"
                                                                                            style={{
                                                                                                overflow: 'auto',
                                                                                                backgroundColor: 'white',
                                                                                            }}
                                                                                        />
                                                                                    ) : (
                                                                                        <iframe
                                                                                            src={`${adminMainUrl}/${value}`}
                                                                                            frameBorder="0"
                                                                                            width="100%"
                                                                                            height="100%"
                                                                                            scrolling="no"
                                                                                            style={{ overflow: 'hidden' }}
                                                                                        />
                                                                                    )
                                                                                )}
                                                                                <span>
                                                                                    <img
                                                                                        src="/img/download-icon.png"
                                                                                        alt="file"
                                                                                    />
                                                                                </span>
                                                                            </button>
                                                                        </a>
                                                                    );
                                                                })
                                                            ) : (
                                                                <div>no file selected</div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className=" col-md-6 py-2">
                                                        <p className="font-medium">Shipment Video</p>
                                                        <div className="col-6 input_box_section file-input-main query-info-flex">
                                                            {pricingQuoteDetailData?.videos ? (
                                                                <a
                                                                    href={`${adminMainUrl}/${pricingQuoteDetailData?.videos}`}
                                                                    target="blank"
                                                                >
                                                                    <button className="folder_main_update_query">

                                                                        <video className="document-video" width="100%" height="100%" controls>
                                                                            <source src={`${adminMainUrl}/${pricingQuoteDetailData?.videos}`} type="video/mp4" />
                                                                        </video>


                                                                        <span>
                                                                            <img
                                                                                src="/img/download-icon.png"
                                                                                alt="file"
                                                                            />
                                                                        </span>
                                                                    </button>
                                                                </a>
                                                            ) : (
                                                                <div>no file selected</div>
                                                            )}
                                                        </div>
                                                    </div>

                                                </div>




                                            </div>
                                            {/* <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                        <h4 className="fw-semibold">Notes</h4>
                                        <div className="d-inline-flex align-items-center">
                                            <div className="form-sort me-3 mt-0">
                                                <i className="ti ti-sort-ascending-2" />
                                                <select className="select">
                                                    <option>Sort By Date</option>
                                                    <option>Ascending</option>
                                                    <option>Descending</option>
                                                </select>
                                            </div>
                                            <a
                                                href="javascript:void(0);"
                                                data-bs-toggle="modal"
                                                data-bs-target="#add_notes"
                                                className="link-purple fw-medium"
                                            >
                                                <i className="ti ti-circle-plus me-1" />
                                                Add New
                                            </a>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="notes-activity">
                                            <div className="card mb-3">
                                                <div className="card-body">
                                                    <div className="d-flex align-items-center justify-content-between pb-2">
                                                        <div className="d-inline-flex align-items-center mb-2">
                                                            <span className="avatar avatar-md me-2 flex-shrink-0">
                                                                <img
                                                                    src="assets/img/profiles/avatar-19.jpg"
                                                                    alt="img"
                                                                />
                                                            </span>
                                                            <div>
                                                                <h6 className="fw-medium mb-1">Darlee Robertson</h6>
                                                                <p className="mb-0">15 Sep 2023, 12:10 pm</p>
                                                            </div>
                                                        </div>
                                                        <div className="mb-2">
                                                            <div className="dropdown">
                                                                <a
                                                                    href="#"
                                                                    className="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                >
                                                                    <i className="ti ti-dots-vertical" />
                                                                </a>
                                                                <div className="dropdown-menu dropdown-menu-right">
                                                                    <a
                                                                        className="dropdown-item"
                                                                        href="javascript:void(0);"
                                                                    >
                                                                        <i className="ti ti-edit text-blue me-1" />
                                                                        Edit
                                                                    </a>
                                                                    <a
                                                                        className="dropdown-item"
                                                                        href="javascript:void(0);"
                                                                    >
                                                                        <i className="ti ti-trash text-danger me-1" />
                                                                        Delete
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <h5 className="fw-medium mb-1">Notes added by Antony</h5>
                                                    <p>
                                                        A project review evaluates the success of an initiative
                                                        and identifies areas for improvement. It can also
                                                        evaluate a current project to determine whether it's on
                                                        the right track. Or, it can determine the success of a
                                                        completed project.{" "}
                                                    </p>
                                                    <div className="d-inline-flex align-items-center flex-wrap">
                                                        <div className="note-download me-3">
                                                            <div className="note-info">
                                                                <span className="note-icon bg-secondary-success">
                                                                    <i className="ti ti-file-spreadsheet" />
                                                                </span>
                                                                <div>
                                                                    <h6 className="fw-medium mb-1">
                                                                        Project Specs.xls
                                                                    </h6>
                                                                    <p>365 KB</p>
                                                                </div>
                                                            </div>
                                                            <a href="javascript:void(0);">
                                                                <i className="ti ti-arrow-down" />
                                                            </a>
                                                        </div>
                                                        <div className="note-download">
                                                            <div className="note-info">
                                                                <span className="note-icon">
                                                                    <img
                                                                        src="assets/img/media/media-35.jpg"
                                                                        alt="img"
                                                                    />
                                                                </span>
                                                                <div>
                                                                    <h6 className="fw-medium mb-1">090224.jpg</h6>
                                                                    <p>365 KB</p>
                                                                </div>
                                                            </div>
                                                            <a href="javascript:void(0);">
                                                                <i className="ti ti-arrow-down" />
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div className="notes-editor">
                                                        <div className="note-edit-wrap">
                                                            <div className="">
                                                                Write a new comment, send your team notification by
                                                                typing @ followed by their name
                                                            </div>
                                                            <div className="text-end note-btns">
                                                                <a
                                                                    href="javascript:void(0);"
                                                                    className="btn btn-light add-cancel"
                                                                >
                                                                    Cancel
                                                                </a>
                                                                <a
                                                                    href="javascript:void(0);"
                                                                    className="btn btn-primary"
                                                                >
                                                                    Save
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div className="text-end">
                                                            <a
                                                                href="javascript:void(0);"
                                                                className="add-comment link-purple fw-medium"
                                                            >
                                                                <i className="ti ti-square-plus me-1" />
                                                                Add Comment
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card mb-3">
                                                <div className="card-body">
                                                    <div className="d-flex align-items-center justify-content-between pb-2">
                                                        <div className="d-inline-flex align-items-center mb-2">
                                                            <span className="avatar avatar-md me-2 flex-shrink-0">
                                                                <img
                                                                    src="assets/img/profiles/avatar-20.jpg"
                                                                    alt="img"
                                                                />
                                                            </span>
                                                            <div>
                                                                <h6 className="fw-medium mb-1">Sharon Roy</h6>
                                                                <p className="mb-0">18 Sep 2023, 09:52 am</p>
                                                            </div>
                                                        </div>
                                                        <div className="mb-2">
                                                            <div className="dropdown">
                                                                <a
                                                                    href="#"
                                                                    className="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                >
                                                                    <i className="ti ti-dots-vertical" />
                                                                </a>
                                                                <div className="dropdown-menu dropdown-menu-right">
                                                                    <a
                                                                        className="dropdown-item"
                                                                        href="javascript:void(0);"
                                                                    >
                                                                        <i className="ti ti-edit text-blue me-1" />
                                                                        Edit
                                                                    </a>
                                                                    <a
                                                                        className="dropdown-item"
                                                                        href="javascript:void(0);"
                                                                    >
                                                                        <i className="ti ti-trash text-danger me-1" />
                                                                        Delete
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <h5 className="fw-medium mb-1">Notes added by Antony</h5>
                                                    <p>
                                                        A project plan typically contains a list of the
                                                        essential elements of a project, such as stakeholders,
                                                        scope, timelines, estimated cost and communication
                                                        methods. The project manager typically lists the
                                                        information based on the assignment.
                                                    </p>
                                                    <div className="d-inline-flex align-items-center flex-wrap">
                                                        <div className="note-download me-3">
                                                            <div className="note-info">
                                                                <span className="note-icon bg-secondary-success">
                                                                    <i className="ti ti-file-text" />
                                                                </span>
                                                                <div>
                                                                    <h6 className="fw-medium mb-1">Andrewpass.txt</h6>
                                                                    <p>365 KB</p>
                                                                </div>
                                                            </div>
                                                            <a href="javascript:void(0);">
                                                                <i className="ti ti-arrow-down" />
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div className="reply-box">
                                                        <p>
                                                            The best way to get a project done faster is to start
                                                            sooner. A goal without a timeline is just a dream.The
                                                            goal you set must be challenging. At the same time, it
                                                            should be realistic and attainable, not impossible to
                                                            reach.
                                                        </p>
                                                        <p>
                                                            Commented by{" "}
                                                            <span className="text-purple">Aeron</span> on 15 Sep
                                                            2023, 11:15 pm
                                                        </p>
                                                        <a href="#" className="btn">
                                                            <i className="ti ti-arrow-back-up-double" />
                                                            Reply
                                                        </a>
                                                    </div>
                                                    <div className="notes-editor">
                                                        <div className="note-edit-wrap">
                                                            <div className="">
                                                                Write a new comment, send your team notification by
                                                                typing @ followed by their name
                                                            </div>
                                                            <div className="text-end note-btns">
                                                                <a
                                                                    href="javascript:void(0);"
                                                                    className="btn btn-light add-cancel"
                                                                >
                                                                    Cancel
                                                                </a>
                                                                <a
                                                                    href="javascript:void(0);"
                                                                    className="btn btn-primary"
                                                                >
                                                                    Save
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div className="text-end">
                                                            <a
                                                                href="javascript:void(0);"
                                                                className="add-comment link-purple fw-medium"
                                                            >
                                                                <i className="ti ti-square-plus me-1" />
                                                                Add Comment
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card mb-0">
                                                <div className="card-body">
                                                    <div className="d-flex align-items-center justify-content-between pb-2">
                                                        <div className="d-inline-flex align-items-center mb-2">
                                                            <span className="avatar avatar-md me-2 flex-shrink-0">
                                                                <img
                                                                    src="assets/img/profiles/avatar-21.jpg"
                                                                    alt="img"
                                                                />
                                                            </span>
                                                            <div>
                                                                <h6 className="fw-medium mb-1">Vaughan</h6>
                                                                <p className="mb-0">20 Sep 2023, 10:26 pm</p>
                                                            </div>
                                                        </div>
                                                        <div className="mb-2">
                                                            <div className="dropdown">
                                                                <a
                                                                    href="#"
                                                                    className="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                >
                                                                    <i className="ti ti-dots-vertical" />
                                                                </a>
                                                                <div className="dropdown-menu dropdown-menu-right">
                                                                    <a
                                                                        className="dropdown-item"
                                                                        href="javascript:void(0);"
                                                                    >
                                                                        <i className="ti ti-edit text-blue me-1" />
                                                                        Edit
                                                                    </a>
                                                                    <a
                                                                        className="dropdown-item"
                                                                        href="javascript:void(0);"
                                                                    >
                                                                        <i className="ti ti-trash text-danger me-1" />
                                                                        Delete
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <p>
                                                        Projects play a crucial role in the success of
                                                        organizations, and their importance cannot be
                                                        overstated. Whether it's launching a new product,
                                                        improving an existing
                                                    </p>
                                                    <div className="notes-editor">
                                                        <div className="note-edit-wrap">
                                                            <div className="">
                                                                Write a new comment, send your team notification by
                                                                typing @ followed by their name
                                                            </div>
                                                            <div className="text-end note-btns">
                                                                <a
                                                                    href="javascript:void(0);"
                                                                    className="btn btn-light add-cancel"
                                                                >
                                                                    Cancel
                                                                </a>
                                                                <a
                                                                    href="javascript:void(0);"
                                                                    className="btn btn-primary"
                                                                >
                                                                    Save
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div className="text-end">
                                                            <a
                                                                href="javascript:void(0);"
                                                                className="add-comment link-purple fw-medium"
                                                            >
                                                                <i className="ti ti-square-plus me-1" />
                                                                Add Comment
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                        </div>
                                    </div>
                                    {/* /Notes */}

                                    {/* /Email */}
                                </div>
                                {/* /Tab Content */}
                            </div>
                            {/* /Contact Details */}
                        </div>
                    </div>
            }

            <QuotationAirExportModal show={show} handleClose={handleClose} pricingQuoteDetailData={pricingQuoteDetailData} />
            {
                pricingQuoteDetailData !== null &&
                <RemarkModal viewData={pricingQuoteDetailData} show={showRemark} handleClose={handleCloseRemark} />
            }
        </div>

    )
}

export default ViewInformation